import React from 'react';
import { personalData } from '../data';

const Contact = () => {
  return (
    <section id="contact" className="section">
      <h2 className="section-title">Contact Us</h2>
      <div className="section-content">
        <p>Ready to unlock your potential? Get in touch with us today.</p>
        <p>
          <a href={`mailto:${personalData.email}`}>{personalData.email}</a>
        </p>
        
        
      </div>
    </section>
  );
};

export default Contact;
